<template>
    <header>
        <a :href="$t(`main.${site}.site_root`)" class="home-logo" :title="$t(`main.${site}.logo_link_title`)">
            <img :alt="$t(`main.${site}.logo_alt`)" :src="siteLogo"/>
        </a>
        <ul>
            <span v-if="showSiteSearch">
                <form role="search" method="get" class="search-form" :action="siteSearch">
                    <label for="s" class="sr-only">Search</label>
                    <input @blur="toggleSiteSearch" autofocus class="search-input" type="search" value="" name="q" id="s" :placeholder="`${$t('menu.search')}...`" autocomplete="off">
                    <div class="form-button-wrapper">
                        <button type="submit">
                            <span class="magnifying-glass-icon"></span>
                            <span class="sr-only">{{ $t('menu.search') }}</span>
                        </button>
                    </div>
                </form>
            </span>
            <li><a :href="$t(`menu.${site}.visit`)">{{ $t('menu.visit') }}</a></li>
            <li><a :href="$t(`menu.${site}.exhibitions`)">{{ $t('menu.exhibitions') }}</a></li>
            <li><a :href="$t(`menu.${site}.learn`)">{{ $t('menu.learn') }}</a></li>
            <li><a :href="$t(`menu.${site}.shop`)">{{ $t('menu.shop') }}</a></li>
            <li><a :href="$t(`menu.${site}.support`)">{{ $t('menu.support') }}</a></li>
            <li><a :href="$t(`menu.${site}.about`)">{{ $t('menu.about') }}</a></li>
            <li>
                <span class="magnifying-glass-icon" @click="toggleSiteSearch">
                    <span class="sr-only">{{ $t('menu.search') }}</span>
                </span>
            </li>
            <li v-if="isEn"><a :href="$t(`menu.${site}.french`) + route">{{ $t('menu.french') }}</a></li>
            <li v-else><a :href="$t(`menu.${site}.english`) + route">{{ $t('menu.english') }}</a></li>
        </ul>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Header',
    data () {
        return {
            showSiteSearch: false   
        }
    },
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
        siteSearch: function () {
            return `${this.$i18n.messages[this.$i18n.locale].main[this.site].site_root}search/`
        },
        isEn: function () {
            return this.$i18n.locale == 'en';
        },
        route: function () {
            if (!this.$route.name) return;
            let altLangMap = {
                'en': 'fr',
                'fr': 'en'
            }

            let altLang = altLangMap[this.$i18n.locale]
            let routeName = this.$route.name.replace(/-/g, '_');
            let altLangRoute = this.$i18n.messages[altLang].routes[routeName];

            if (this.$route.fullPath.includes('?')) {
                let query = `?${this.$route.fullPath.split('?').pop()}`;
                if (query) {
                    altLangRoute += `${query}`
                }
            } else if (this.$route.name.includes('detail')) {
                altLangRoute = `${this.$route.fullPath.substring(1)}`;
            }

            return altLangRoute;
        },
        siteLogo: function () {
            let imgName = this.$i18n.messages[this.$i18n.locale].main[this.site].museum_name_img;
            return require('../assets/'+imgName)
        }
    },
    methods: {
        toggleSiteSearch () {
            this.showSiteSearch = !this.showSiteSearch;
        }
    }
}
</script>

<style scoped lang="scss">
    $desktop-height: 120px;
    $tablet-height: 80px;

    header {
        background: $white;
        height: $desktop-height;
        display: flex;
        justify-content: space-between;
        padding-left: $side-padding;
        position: relative;

        .home-logo {
            display: flex;

            img {
                width: 303px;
            }
        }

        .search-form {
            position: absolute;
            background-color: #fff;
            width: 80%;
            height: 70px;
            top: 1.75rem;
            right: 145px;
            z-index: 3;
            display: flex;
            align-items: center;

            input {
                background-color: #fff;
                height: 100%;
                width: 100%;
                text-transform: uppercase;
                font-family: 'Futura';
                font-weight: bold;
                padding-left: 20px;
                border: none;

                &::placeholder {
                    opacity: .4;
                }
                
                &::-webkit-search-decoration,
                &::-webkit-search-cancel-button,
                &::-webkit-search-results-button,
                &::-webkit-search-results-decoration { display: none; }
            }
            .form-button-wrapper {
                position: absolute;
                right: 0;
                display: inline-block;
                height: 100%;
                width: 50px;
            }
            button {
                display: inline-block;
                background: none;
                border: none;
                height: 100%;
                width: 100%;
            }

            
                .magnifying-glass-icon {
                    height: 24px;
                    width: 24px;
                    cursor: pointer;

                    &:after {
                        content: url('../assets/images/icon-search-dark.svg');
                        display: flex;
                        padding-top: 4px;
                        justify-content: center;
                        align-items: center;
                        height: 16px;
                        width: 16px;
                    }

                }
        }

        ul {
            background: $menu-gray;
            display: flex;
            align-items: center;
            position: relative;
            padding-left: 100px;

            li {
                z-index: 2;
                margin: 0 40px 0 0;

                a {
                    color: $white;
                    text-decoration: none;
                    font-weight: bold;
                    text-transform: uppercase;
                    font-family: 'Futura';
                    font-size: .9rem;
                    letter-spacing: .6px;
                    box-sizing: border-box;

                    &:hover {
                        color: #a4a6a4;
                    }
                }

                .magnifying-glass-icon {
                    height: 24px;
                    width: 24px;
                    cursor: pointer;

                    &:after {
                        content: url('../assets/images/icon-search-white.svg');
                        display: flex;
                        padding-top: 4px;
                        justify-content: center;
                        align-items: center;
                        height: 16px;
                        width: 16px;
                    }

                    &:hover:after {
                        content: url('../assets/images/icon-search.svg');
                    }
                }
            }
        }
    }

    .cmh header {
        ul:before {
            z-index: 1;
            display: block;
            content: "";
            width: $desktop-height;
            height: $desktop-height;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            -ms-border-radius: 50%;
            -o-border-radius: 50%;
            border-radius: 50%;
            background: #8a8d8a;
            left: -60px;
            position: absolute;
            top: 0;
        }
    }

    .cwm header {
        ul:before {
            display: block;
            content: "";
            width: 0;
            height: 0;
            right: 100%;
            position: absolute;
            top: 0;
            border-bottom: $desktop-height solid #8a8d8a;
            border-left: $desktop-height solid transparent;    
        }
    }

    
    @media print {
        header ul {
            display: none;
        }
    }

    @media (max-width: 1500px) {
        .home-logo img {
            width: 85%;
        }

        header ul {
            padding-left: 40px;
        }
    }
    @media (max-width: $mq-max-width-desktop) {
        .home-logo img {
            width: 80%;
        }

        header {
            height: $tablet-height;
            ul li {
                margin: 0 .65rem;
            }

            .search-form {
                height: 60px;
                top: 0.65rem;
                right: 95px;
            } 

        } 

        .cmh header {
            ul:before {
                width: $tablet-height;
                height: $tablet-height;
                left: -34px;
            }
        }

        .cwm header {
            ul:before {
                border-bottom: $tablet-height solid #8a8d8a;
                border-left: $tablet-height solid transparent;    
            }
        }
    }

    @media (max-width: $mq-max-width-desktop-sml) {
        header {
            .home-logo img {
                width: 80%;
            }
            ul li {
                a {
                    font-size: 0.6rem;
                }
            }
        }
    }
        
    @media (max-width: $mq-max-width-tablet) {
        header {
            display: none;
        }   
    }

    @media print {
        nav {
            display: none;
        }
    }
</style>